// Zentrale Datei für alle wichtigen Business-Informationen
// Passe die Werte nach Bedarf an

const businessInfo = {
  displayCompanyName: "Payroll Experten",
  companyName: "Payroll Experten",
  address: {
    street: "Maximilianstrasse 4",
    zip: "80539",
    city: "München",
    country: "Deutschland",
  },
  email: "anfragen@payroll-experten.de",
  phone: "+49 151 65004597",
  website: "https://www.payroll-experten.de",
  vatId: "",
  taxNumber: "",
  ceo: "Natalia Hill",
};

export default businessInfo;
